export var FEATURE_FLAGS;
(function (FEATURE_FLAGS) {
    FEATURE_FLAGS["NEW_HOMEPAGE_EXPERIENCE"] = "new-homepage-experience";
})(FEATURE_FLAGS || (FEATURE_FLAGS = {}));
export var ContextType;
(function (ContextType) {
    ContextType["USER"] = "user";
})(ContextType || (ContextType = {}));
export const DEFAULT_FLAG_VALUE = false;
//# sourceMappingURL=flags.const.js.map